import { pdfjs } from 'react-pdf';

/**
 * Single setup point for the PDF.js worker.
 *
 * Each consuming app copies `pdf.worker.min.mjs` from `pdfjs-dist` into its
 * build output via a Vite plugin (see `copyPdfWorkerPlugin` in the app's
 * `vite.config.ts`). The worker is then served from the same origin as the
 * app — no runtime dependency on unpkg.com CDN.
 *
 * The version is embedded in the filename so browsers cache-bust on upgrades.
 *
 * `import.meta.env.BASE_URL` is Vite's built-in base path (defaults to "/").
 * If an app ever sets `base: '/subpath/'` in vite.config.ts, the worker URL
 * will resolve correctly without code changes here.
 */
pdfjs.GlobalWorkerOptions.workerSrc = `${import.meta.env.BASE_URL}pdf.worker.${pdfjs.version}.min.mjs`;
